function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document.querySelector(".cart-drawer").classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count, itemKey) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
    if (el.textContent !== '0') {
      el.classList.add('active');
    } else {
      el.classList.remove('active');
    }
  });

  // Update individual item count if itemKey is provided
  if (itemKey) {
    const itemQuantityElement = document.querySelector(`[data-line-item-key="${itemKey}"] .cart-drawer-quantity-selector-input`);
    if (itemQuantityElement) {
      itemQuantityElement.value = count;
    }
  }
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
}

function addCartDrawerListeners() {
document.querySelectorAll(".remove-item-button").forEach((removeButton) => {
  removeButton.addEventListener("click", async (event) => {
    event.preventDefault();

    const lineItemKey = removeButton.getAttribute("data-line-key");

    if (!lineItemKey) {
      console.error("Error: data-line-item-key is missing.");
      return;
    }

    try {
      console.log("Sending request to remove item:", lineItemKey);

const response = await fetch("/cart/change.js", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({
    id: lineItemKey,
    quantity: 0,
  }),
  credentials: 'include',
});


      const cart = await response.json();

      updateCartItemCounts(cart.item_count, lineItemKey);

      // Update cart drawer
      await updateCartDrawer();
      saveCartToLocalStorage(cart);
    } catch (error) {
      console.error("Error removing item:", error.message);
    }
  });
});



  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement
          .parentElement;
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        // Ajax update
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
        saveCartToLocalStorage(cart); // Save cart to localStorage
      });
    });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        closeCartDrawer();
      });
    });
}

function saveCartToLocalStorage(cart) {
  localStorage.setItem('shopify-cartstor', JSON.stringify(cart));
}

addCartDrawerListeners();

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    // Submit form with ajax
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    // Get cart count
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);

    // Update cart
    updateCartDrawer();
    saveCartToLocalStorage(cart); // Save cart to localStorage

    // Open cart drawer
    openCartDrawer();
  });
});

document.querySelectorAll('.quantity-container button').forEach((button) => {
  button.addEventListener("click", () => {
    const input = button.parentElement.querySelector('.quantity-amount');
    const value = Number(input.value);
    const isPlus = button.classList.contains('plus');
    const key = button.closest('tr').getAttribute('data-key');

    if (isPlus) {
      const newValue = value + 1;
      input.value = newValue;
      changeItemQuantity(key, newValue);
    } else if (value > 1) {
      const newValue = value - 1;
      input.value = newValue;
      changeItemQuantity(key, newValue);
    }

  });
});

function changeItemQuantity(key, quantity) {
  axios.post('/cart/change.js', {
    id: key,
    quantity,
  }).then((res) => {
    const format = document.querySelector('[data-money-format]').getAttribute('data-money-format');

    const totalPrice = formatMoney(res.data.total_price, format);
    const item = res.data.items.find(item => item.key === key);
    const itemPrice = formatMoney(item.final_line_price, format);
    
    document.querySelector('.total-price').textContent = totalPrice;
    document.querySelector(`[data-key="${key}"] .line-item-price`).textContent = itemPrice;

    // Update cart
    updateCartItemCounts(res.data.item_count);
    saveCartToLocalStorage(res.data); // Save cart to localStorage
  });
}